/**
 * Единицы HRV: логарифм для счёта, миллисекунды для показа — 2026-08-03.
 *
 * `/athlete/metrics/hrv` отдаёт lnRMSSD — и ряд, и базу. Логарифм берут не
 * из вредности: распределение RMSSD скошено, и на логарифме база и
 * z-оценка получаются честнее. Но человеку показывают миллисекунды, и в
 * `wellness.hrv` лежат именно они.
 *
 * ЧТО СЛОМАЛОСЬ. «Сегодня» считал отклонение как `hrv_мс − base_ln`: при
 * HRV 67 мс и базе 4.049 экран печатал «+63» вместо «+10». Ошибку прятала
 * арифметика: логарифм — маленькое число, разность выходит близкой к самому
 * значению, и «HRV 67, +63» выглядит правдоподобно, хотя означает бессмыслицу
 * («почти весь пульсовый разброс — превышение над нормой»).
 *
 * «Форма» ту же базу показывала верно, потому что делала exp() перед
 * сравнением. Один эндпоинт, два экрана, разные единицы — расхождение,
 * которое видно только если положить страницы рядом.
 *
 * ПРАВИЛО. Всё, что уходит на экран, приводится к миллисекундам ЗДЕСЬ.
 * Логарифм не должен покидать слой расчёта.
 */

/** База из lnRMSSD в миллисекунды — та же величина, в человеческих единицах. */
export function baselineToMs(baselineLn: number): number {
  return Math.exp(baselineLn);
}

/**
 * Отклонение сегодняшнего HRV от базы, в миллисекундах.
 *
 * @param latestHrvMs текущее значение (wellness.hrv, уже мс)
 * @param baselineLn  база с /athlete/metrics/hrv (lnRMSSD)
 * @returns целое число мс, либо null — если сравнивать не с чем
 */
export function hrvDeltaMs(
  latestHrvMs: number | null | undefined,
  baselineLn: number | null | undefined,
): number | null {
  if (latestHrvMs == null || baselineLn == null) return null;
  if (!Number.isFinite(latestHrvMs) || !Number.isFinite(baselineLn)) return null;
  return Math.round(latestHrvMs - baselineToMs(baselineLn));
}
